<template>
	<SelectFavoriteAppsMenu :nudge-right="-350" :nudge-bottom="48" hidePrevious>
		<template #activator>
			<AnemicButton tile class="add-button px-7">Add apps</AnemicButton>
		</template>
	</SelectFavoriteAppsMenu>
</template>

<script>
import SelectFavoriteAppsMenu from '@/components/SelectFavoriteApps/SelectFavoriteAppsMenu.vue';
export default {
	name: 'ManageAppsSelectFavoriteMenu',
	components: { SelectFavoriteAppsMenu },
};
</script>
<style scoped lang="scss">
.add-button {
	height: 45px !important;
	font-size: 16px !important;
	border-radius: 10px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	background: #605ed9 !important;
	letter-spacing: 0.21px !important;
}
</style>
